import * as en from './en';
import * as es from './es';
//
const narration = { en, es };

export default ({ session: { language } }) => narration[language]?._1;
